<div class="hygiene">
  <div class="table-actions">
    <app-hygiene-filters class="full-width" [pageFilters]="pageFilters"></app-hygiene-filters>
  </div>

  <div class="table-header">
    @if (totalItems > -1) {
      <div class="items-amount">
        {{ 'common.found' | labelsProvider }} {{ totalItems | number }}
        {{ 'hygienePage.title' | labelsProvider | lowercase }}
      </div>
    }
    <div class="table-header-right">
      <app-columns-selection
        class="columns-selection"
        [columns]="columns()"
        [pageName]="pageName"
        (columnsSelected)="columnsSelected($event)"
      />

      @if (
        accessService.renderExportCSVButton(accountCategory$ | async) &&
        (accountCategory$ | async) !== AccountCategory.poc
      ) {
        <div class="export-button-container">
          <app-violations-export
            [violationsDataType]="violationsDataType"
            [selectedFilters]="pageFilters.getSelectedFilters()"
            [sort]="sorts"
          >
          </app-violations-export>
        </div>
      }
    </div>
  </div>

  <div class="table" [ngClass]="{ 'table-height-on-filters': optionsAreSelected }">
    @if (multiActionsIsLoading$ | async) {
      <mat-progress-spinner class="multi-actions-loading" color="primary" mode="indeterminate"> </mat-progress-spinner>
    }
    <app-hygiene-vertical-filters
      [ngClass]="{ 'filters-all': isFiltersMenuOpen }"
      (optionOnSelection)="tablesFiltersChange($event)"
      [pageFilters]="pageFilters"
      [isFiltersMenuOpen]="isFiltersMenuOpen"
      (filtersOnMenuStateChange)="filtersOnMenuStateChange($event)"
    >
    </app-hygiene-vertical-filters>

    <app-prime-table
      #table
      [ngClass]="!isFiltersMenuOpen ? 'table-collapsed-menu' : 'table-component'"
      queryParamProperty="violation"
      [data$]="hygieneCurrentPage$"
      [columns]="columns()"
      [rowsPerPage]="defaultPageSize"
      [isLoading]="(isLoading$ | async) === true"
      (checkedRowsUpdate)="onCheckboxClick($event)"
      [sortedColumn$]="pageFilters.sortedColumn$"
      [pageInfo]="pageInfo$.value"
      (pageOnChange)="onPagination($event)"
      (rowActionOnClick)="actionOnClick($event)"
      [checkedRowsSupportedActions$]="multiSelectedMenuActions$"
      (rowSelected)="rowSelected($event)"
      (rowUnselected)="rowUnselected()"
      (multiCheckOnClick)="multiSelectedActionClick($event)"
      [expandFilterResultControl]="expandFilterResultControl"
      tableNotFoundText="You don't have any hygiene rules"
      tableNotFoundIcon="assets/images/common/no-violations-found.svg"
    />
  </div>
</div>
